import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
// import { useTheme as useLiosTheme } from '../../theme/ThemeProvider'
import styles from './Drawer.module.css'
import DrawerItem from '../DrawerItem/DrawerItem'

const NAV_ITEMS = [
  { title: 'Overview', icon: 'img/calendar.svg', path: '/' as const },
  { title: 'Brain Dump', icon: 'img/brain.svg', path: '/brain-dump' as const },
  { title: 'Habits', icon: 'img/habits.svg', path: '/habits' as const },
  { title: 'Mood', icon: 'img/journal.svg', path: '/mood' as const },
  { title: 'Workspace', icon: 'img/workspace.svg', path: '/workspace' as const },
] as const

type DrawerProps = {
  onNavigate?: () => void
  onLogout?: () => void
}

const Drawer = ({ onNavigate, onLogout }: DrawerProps) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  // Light/dark toggle: hidden until theme polish is finished.
  // const { theme, toggleTheme } = useLiosTheme()
  // const themeLabel =
  //   theme === 'dark'
  //     ? { action: 'Light mode', hint: 'Switch to light appearance' }
  //     : { action: 'Dark mode', hint: 'Switch to dark appearance' }

  return (
    <div className={styles.container}>
      <div className={styles.drawerTop}>
        <div className={styles.DrawerTop__Header}>
          <img
            className={styles.brandLogo}
            src={`${process.env.PUBLIC_URL}/img/lios-logo.svg`}
            alt="Lios"
            decoding="async"
          />
        </div>
        <nav className={styles.DrawerTop__NavItems} aria-label="Main">
          {NAV_ITEMS.map((item) => (
            <DrawerItem
              key={item.title}
              title={item.title}
              icon={item.icon}
              active={item.path !== null && (pathname === item.path || (item.path !== '/' && pathname.startsWith(item.path)))}
              onClick={() => {
                if (item.path !== null) {
                  navigate(item.path)
                  onNavigate?.()
                } else {
                  navigate('/', { replace: true })
                  onNavigate?.()
                }
              }}
            />
          ))}
        </nav>
      </div>
      <div className={styles.drawerBottom}>
        <DrawerItem
          title="Logout"
          icon="img/logout.svg"
          active={false}
          onClick={() => {
            onLogout?.()
            onNavigate?.()
          }}
        />
      </div>
      {/*
      <footer className={styles.themeFooter}>
        <button
          type="button"
          className={styles.themeToggle}
          onClick={toggleTheme}
          aria-label={themeLabel.hint}
        >
          {themeLabel.action}
        </button>
      </footer>
      */}
    </div>
  )
}

export default Drawer